module.exports = __webpack_public_path__ + "img/appl.79193855.svg";